<template>
  <form @submit="onSearch" class="search-content">
    <input 
        v-model="value" 
        type="text" 
        placeholder="搜索..."
    >
    <button type="submit">
        <img class="buttonIcon" @click="onSearch" src="../assets/chat/searchIcon.png" alt="">
    </button>
  </form>
</template>

<script>
export default {
    name:"search",
    data(){
        return{
            value:''
        }
    },
    methods:{
        onSearch(e){
            e.preventDefault();
            if(!this.value) return
            this.$emit('changeSearch',this.value);
        }
    }
}
</script>

<style lang="less" scoped>
.search-content{
    width: 400px;
    height: 40px;
    border-radius: 100px;
    padding: 0 19px;
    border: 1px solid #808080;  
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 1s ease;
    background: transparent;
    input{
        flex: 1;
        height: 100%;
        background: transparent;
    }
    .buttonIcon{
        width: 12px;
        height: 12px;
        margin-left:10px;
        cursor: pointer;
    }
}
</style>